<script setup lang="ts">
import { computed } from 'vue';
import type { StationDistance } from '@models/transport.ts';

defineProps<{ stationDistance: StationDistance }>();

const cdnUrl = computed(() => window.CDN_URL);
</script>

<template>
  <ul
    v-if="stationDistance"
    class="selection-item-transports"
  >
    <li
      v-for="unique_line in stationDistance.unique_lines"
      :key="unique_line"
      class="selection-item-transports__item"
    >
      <img
        :src="`${cdnUrl}/images/img_trans.gif`"
        :class="`icon-${unique_line}`"
        :alt="unique_line"
      >
    </li>
  </ul>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.selection-item-transports {
  padding-left: 0;
  display: flex;
  gap: rem(4);

  &__item {
    display: flex;

    img {
      height: rem(16);
      width: rem(16);
    }
  }
}
</style>
